var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.1 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #000;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19 {\n        stroke-miterlimit: 10;\n      }\n\n      .st0, .st1, .st5, .st7, .st9, .st10, .st13, .st14, .st15, .st17, .st18 {\n        fill: none;\n      }\n\n      .st1, .st2, .st3, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19 {\n        stroke: gray;\n      }\n\n      .st1, .st3, .st5, .st9, .st10, .st13, .st14, .st15 {\n        stroke-width: .8px;\n      }\n\n      .st2, .st3, .st8 {\n        fill: #44b649;\n      }\n\n      .st20, .st4, .st6, .st16 {\n        fill: #fff;\n      }\n\n      .st4 {\n        stroke: #7f7f7f;\n      }\n\n      .st5 {\n        stroke-dasharray: 7.5 1.9;\n      }\n\n      .st7, .st8, .st16 {\n        stroke-width: .5px;\n      }\n\n      .st9 {\n        stroke-dasharray: 6.8 1.7;\n      }\n\n      .st10 {\n        stroke-dasharray: 9.7 2.4;\n      }\n\n      .st11 {\n        fill: #ccc;\n        stroke-dasharray: 3 2;\n      }\n\n      .st21 {\n        display: none;\n      }\n\n      .st13 {\n        stroke-dasharray: 8.4 2.1;\n      }\n\n      .st14 {\n        stroke-dasharray: 7.6 1.9;\n      }\n\n      .st15 {\n        stroke-dasharray: 7.5 1.9;\n      }\n\n      .st22 {\n        fill: gray;\n      }\n\n      .st18 {\n        stroke-dasharray: 2.9 2.9;\n      }\n\n      .st19 {\n        fill: #2c5583;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 0.5,
    y: 0.5,
    width: 29.9,
    height: 29.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "DEF",
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M15.5,30.4s7.8-2,9.5-4c3.6-4.2,5.4-21.8,5.4-21.8,0,0-5.2-2.8-15-4.1C5.7,1.8.5,4.6.5,4.6c0,0,1.8,17.5,5.4,21.8,1.7,2,9.5,4,9.5,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16,28.3s6.3-2,7.7-3.7c3-3.6,4.6-18.2,4.6-18.2,0,0-4-2-12.2-3.1v25Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "MDEF",
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M15.5,30.4s7.8-2,9.5-4c3.6-4.2,5.4-21.8,5.4-21.8,0,0-5.2-2.8-15-4.1C5.7,1.8.5,4.6.5,4.6c0,0,1.8,17.5,5.4,21.8,1.7,2,9.5,4,9.5,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16,28.3s6.3-2,7.7-3.7c3-3.6,4.6-18.2,4.6-18.2,0,0-4-2-12.2-3.1v25Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "DB",
    className: "st21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M15.5,30.4s7.8-2,9.5-4c3.6-4.2,5.4-21.7,5.4-21.7,0,0-5.1-2.8-14.9-4.1C5.7,1.9.5,4.7.5,4.7c0,0,1.8,17.5,5.4,21.7,1.7,2,9.5,4,9.5,4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.9,8.7c.3-2.4.5-4,.5-4,0,0-1.3-.7-3.7-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M24.7,2.5c-2.4-.7-5.5-1.4-9.2-1.9-4.3.6-7.8,1.4-10.2,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.2,3.2c-2.4.8-3.7,1.5-3.7,1.5,0,0,.2,1.6.5,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.3,10.5c.9,5.5,2.4,13.3,4.6,15.9,1.7,2,9.5,4,9.5,4,0,0,7.8-2,9.5-4,2.4-2.8,4-11.3,4.8-16.8"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M15.2,23.4s4.2-1.1,5.1-2.1c1.9-2.3,2.9-11.6,2.9-11.6,0,0-2.7-1.5-7.9-2.2-5.2.7-7.9,2.2-7.9,2.2,0,0,1,9.3,2.9,11.6.9,1.1,5.1,2.1,5.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.4,22.1s3.3-.8,4.1-1.7c1.6-1.9,2.4-9.7,2.4-9.7,0,0-2.1-1.1-6.5-1.6,0,0,0,13,0,13Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.6,11.6c.3-2.3.5-4,.5-4,0,0-1.3-.7-3.7-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M20.1,5.5c-1.4-.3-3-.6-4.8-.9-2.4.3-4.4.7-6,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.2,6.2c-2.5.8-3.7,1.4-3.7,1.4,0,0,.2,1.7.5,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M5.3,13.5c.7,3.8,1.7,8.3,3.1,10,1.2,1.4,6.9,2.9,6.9,2.9,0,0,5.7-1.5,6.9-2.9,1.5-1.8,2.6-7,3.3-10.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.7,10.1c.3-2.3.5-4,.5-4,0,0-1.3-.7-3.7-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M22.8,4.2c-2-.6-4.5-1.1-7.5-1.5-3.5.5-6.3,1.1-8.3,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.1,4.7c-2.5.8-3.7,1.5-3.7,1.5,0,0,.2,1.6.5,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M3.2,12c.8,4.7,2.1,10.8,3.9,12.9,1.5,1.7,8.2,3.5,8.2,3.5,0,0,6.7-1.7,8.2-3.5,1.9-2.3,3.3-9.1,4-13.8"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SPD",
    className: "st21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M15.7,6.5s2.5,1.9,3.4,2.4c1.2.6,5,2,5,2,0,0-.6,2.4-1.2,2.9-.3.3-1.7.3-1.7.3l-.7,5.1s1.8,2.1,3.2,3.5c.4.3.9.9,1.2.9,1,0,4-.5,4.6.3.5.8.5,1.4.6,2.4,0,.4-.2,1.4-.2,1.4,0,0,.7.4.6.8,0,.4-.9,1.2-.9,1.2l-9.5-.4-3.4-1.7-1.1-1.2-1.2.3s-4.9-2-5.9-3.1c-.2-.2-.6-1-.5-1.3.1-.3.6-.4.6-.4,0,0,.1-.8.1-1.3,0-.7.9-1.9,1.2-2.6.4-.7,1.5-1.3,2-1.7.4-.3.8-1.2,1-1.6.5-.9,1.3-4,1.3-4,0,0-1.3-.9-1.3-1.4,0-.9,2.8-2.6,2.8-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M23,24.5s.3-.5.6-.9c0-.1.1-.2.2-.3,0,0,.2,0,.3,0,.2,0,.5.1.5.1h0c0,0,0,.3,0,.5,0,.1-.1.2-.2.3-.1,0-.2,0-.4.1-.5.2-1,.3-1,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M21,22.6s.6-.3,1.2-.5c.1,0,.3-.1.4-.2.1,0,.3,0,.4,0,.2.1.4.3.4.3h0c0,.1-.1.3-.3.5-.1,0-.2.1-.4.2-.1,0-.3,0-.5,0-.6,0-1.2-.2-1.2-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M18.5,12.8s.8,0,1.5.2c.2,0,.4,0,.5,0,.2,0,.3.2.4.3.2.2.3.5.3.5h0c0,0-.3.2-.6.2-.2,0-.3,0-.5,0-.2,0-.3-.2-.4-.3-.6-.4-1.2-.9-1.2-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M11,22.8s.8.4,1.7.8c.2.1.4.2.6.3.2.1.3.2.5.4.3.2.4.4.4.4h0s-.3,0-.6-.1c-.2,0-.4-.1-.5-.3-.2-.1-.4-.3-.6-.4-.8-.5-1.5-1.1-1.5-1.1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.9,24c-.2-.3-.6-1.2-.5-1.5.1-.3.6-.5.6-.5,0,0,.1-.9.1-1.5,0-.8.8-2.2,1.2-3,.4-.8,1.5-1.5,2-2,.4-.3.8-1.4,1-1.9.5-1.1,1.2-4.6,1.2-4.6,0,0-1.3-1.1-1.3-1.7,0-1.1,2.8-3,2.8-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1.4,20.9c-.2-.3-.6-1.2-.5-1.5.1-.3.3-.6.3-.6,0,0,.5-.8.4-1.3,0-.8.8-2.2,1.2-3,.4-.8,1.5-1.5,2-2,.4-.3.8-1.4,1-1.9.5-1.1.3-4.1.3-4.1,0,0-.4-1.6-.4-2.1,0-1.1,2.8-3,2.8-3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 0.6,
    y1: 9,
    x2: 17.2,
    y2: 14.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 5.7,
    y1: 14.5,
    x2: 15.4,
    y2: 17.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 3.4,
    y1: 17.5,
    x2: 17.2,
    y2: 21.7
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ACC",
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2.9,10.9C2.9,6.5,6.5,2.9,11,2.9v2.8c-2.9,0-5.2,2.3-5.2,5.2,0,0-2.8,0-2.8,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 14.4,
    y: 0.5,
    width: 2.2,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M20.1,2.9c4.4,0,8,3.6,8,8h-2.8c0-2.9-2.3-5.2-5.2-5.2v-2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 24.5,
    y: 14.4,
    width: 6,
    height: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M28.1,20c0,4.4-3.6,8-8,8v-2.8c2.9,0,5.2-2.3,5.2-5.2h2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 14.4,
    y: 24.5,
    width: 2.2,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M11,28.1c-4.4,0-8-3.6-8-8h2.8c0,2.9,2.3,5.2,5.2,5.2v2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 0.5,
    y: 14.4,
    width: 6,
    height: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M17,15.8c0,.8-.6,1.4-1.4,1.4s-1.4-.6-1.4-1.4.6-1.4,1.4-1.4,1.4.6,1.4,1.4Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "MACC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2.9,10.9C2.9,6.5,6.5,2.9,11,2.9v2.8c-2.9,0-5.2,2.3-5.2,5.2,0,0-2.8,0-2.8,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 14.4,
    y: 0.5,
    width: 2.2,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M20.1,2.9c4.4,0,8,3.6,8,8h-2.8c0-2.9-2.3-5.2-5.2-5.2v-2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 24.5,
    y: 14.4,
    width: 6,
    height: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M28.1,20c0,4.4-3.6,8-8,8v-2.8c2.9,0,5.2-2.3,5.2-5.2h2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 14.4,
    y: 24.5,
    width: 2.2,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M11,28.1c-4.4,0-8-3.6-8-8h2.8c0,2.9,2.3,5.2,5.2,5.2v2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 0.5,
    y: 14.4,
    width: 6,
    height: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M17,15.8c0,.8-.6,1.4-1.4,1.4s-1.4-.6-1.4-1.4.6-1.4,1.4-1.4,1.4.6,1.4,1.4Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M3.1,6.2c6-.6,17.9.4,18,9.3l-3.4.3,5.6,4.2,4.7-5.2-3.2.3C24.7,2.8,10,1.4,1.8,2.2l1.3,4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 23.1,
    cy: 25.9,
    rx: 2.1,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M30.6,25.9c0,1.7-3.4,3.1-7.5,3.1s-7.5-1.4-7.5-3.1,3.4-3.1,7.5-3.1,7.5,1.4,7.5,3.1Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "RNG",
    className: "st21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 0.5,
    y: 4,
    width: 5,
    height: 19.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 5.6,
    y: 4,
    width: 5,
    height: 19.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "30.3 13.6 20.5 2.8 20.5 4 10.6 4 10.6 23.2 20.5 23.2 20.5 24.4 30.3 13.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: ".5 27.7 .5 29.6 10.5 29.6 10.5 27.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "10.5 27.7 10.5 29.6 20.4 29.6 20.4 27.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "20.4 27.7 20.4 29.6 30.3 29.6 30.3 27.7"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "MRNG",
    className: "st21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st19",
    x: 0.5,
    y: 4,
    width: 5,
    height: 19.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st19",
    x: 5.6,
    y: 4,
    width: 5,
    height: 19.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "30.3 13.6 20.5 2.8 20.5 4 10.6 4 10.6 23.2 20.5 23.2 20.5 24.4 30.3 13.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: ".5 27.7 .5 29.6 10.5 29.6 10.5 27.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "10.5 27.7 10.5 29.6 20.4 29.6 20.4 27.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "20.4 27.7 20.4 29.6 30.3 29.6 30.3 27.7"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    className: "st21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "12.1 8.5 14.8 1.7 17.5 8.5 26.5 3.3 21.3 12.3 28.1 15 21.3 17.7 26.5 26.8 17.5 21.5 14.8 28.3 12.1 21.5 3 26.8 8.2 17.7 1.4 15 8.2 12.3 3 3.3 12.1 8.5"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "POW",
    className: "st21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "12.7 8.6 15.5 1.5 18.3 8.6 27.9 3.1 22.3 12.6 29.5 15.4 22.3 18.3 27.9 27.8 18.3 22.3 15.5 29.4 12.7 22.3 3.2 27.8 8.7 18.3 1.5 15.4 8.7 12.6 3.2 3.1 12.7 8.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "14.2 12.2 15.5 8.9 16.8 12.2 21.3 9.7 18.7 14.1 22 15.5 18.7 16.8 21.3 21.2 16.8 18.7 15.5 22 14.2 18.7 9.7 21.2 12.3 16.8 8.9 15.5 12.3 14.1 9.7 9.7 14.2 12.2"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "MPOW",
    className: "st21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "12.7 8.6 15.5 1.5 18.3 8.6 27.9 3.1 22.3 12.6 29.5 15.4 22.3 18.3 27.9 27.8 18.3 22.3 15.5 29.4 12.7 22.3 3.2 27.8 8.7 18.3 1.5 15.4 8.7 12.6 3.2 3.1 12.7 8.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "14.2 12.2 15.5 8.9 16.8 12.2 21.3 9.7 18.7 14.1 22 15.5 18.7 16.8 21.3 21.2 16.8 18.7 15.5 22 14.2 18.7 9.7 21.2 12.3 16.8 8.9 15.5 12.3 14.1 9.7 9.7 14.2 12.2"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "DMG",
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M12,19l4,4s6.9-7,8.9-10.4c1.4-2.3,4.4-10.8,4.4-10.8,0,0-8.6,3-10.8,4.4-3.4,2.1-10.4,8.9-10.4,8.9l4,4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "13.1 20.1 22.5 8.5 10.8 17.8 13.1 20.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M6.8,24.2l2.7,2.7,3.2-3.2s1.1,1.6,1.7,1.6c.7,0,2-2,2-2l-4.4-4.4-4.4-4.4s-2,1.3-2,2c0,.6,1.6,1.7,1.6,1.7l-3.2,3.2,2.7,2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M9.5,26.9s-1.5,2.2-2.2,2.2c-1.9,0-5.5-3.5-5.5-5.5,0-.8,2.2-2.2,2.2-2.2l5.5,5.5Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "MDMG",
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M12,19l4,4s6.9-7,8.9-10.4c1.4-2.3,4.4-10.8,4.4-10.8,0,0-8.6,3-10.8,4.4-3.4,2.1-10.4,8.9-10.4,8.9l4,4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "13.1 20.1 22.5 8.5 10.8 17.8 13.1 20.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M6.8,24.2l2.7,2.7,3.2-3.2s1.1,1.6,1.7,1.6c.7,0,2-2,2-2l-4.4-4.4-4.4-4.4s-2,1.3-2,2c0,.6,1.6,1.7,1.6,1.7l-3.2,3.2,2.7,2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M9.5,26.9s-1.5,2.2-2.2,2.2c-1.9.2-5.5-3.5-5.5-5.5,0-.8,2.2-2.2,2.2-2.2l5.5,5.5Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "AWA",
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M29.4,17.7s-13.9,20.7-27.8,0h0c13.9-20.7,27.8,0,27.8,0h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 15.5,
    cy: 17.7,
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 15.5,
    cy: 17.7,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1.6,11.9s.3-.4.8-1.2c.2-.4.6-.8,1-1.3.2-.2.4-.5.6-.8.2-.3.6-.5.8-.7.3-.3.6-.5,1-.8.3-.3.7-.5,1.1-.8.8-.5,1.6-1,2.5-1.4.9-.4,1.9-.7,2.9-.9,1-.2,2.1-.3,3.1-.3,1.1,0,2.1.2,3.1.5,1,.3,2,.6,2.9,1,1.8.8,3.3,1.8,4.6,2.8.3.3.6.4.9.7.2.3.5.5.7.8.4.5.8.9,1,1.3.5.7.8,1.2.8,1.2,0,0-.4-.3-1.1-.9-.4-.3-.8-.6-1.3-1-.2-.2-.5-.4-.8-.6-.3-.2-.5-.5-.8-.7-1.2-.9-2.7-1.9-4.4-2.7-.8-.4-1.8-.7-2.7-1-.9-.2-1.9-.4-2.9-.4-1,0-2,0-2.9.3-1,.2-1.9.5-2.7.9-.8.4-1.6.8-2.3,1.3-.4.2-.7.5-1,.7-.3.2-.6.5-.9.7-.5.5-1.1.9-1.6,1.3-.5.4-.9.7-1.2,1-.7.6-1.1.9-1.1.9Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "WGT",
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M25.8,11.4l-.9-1h-3.9c3.6,0,3.3-1.6,3.3-5,0-2.7-4.2-4.8-8.9-4.8S6.5,2.6,6.5,5.4c0,3.4-.3,5,3.3,5h-3.9l-.9,1L.6,25.6l1.6,4.7h26.4l1.6-4.7-4.4-14.3ZM15.4,7.9c-6,0-6.2.5-6.2-2.3s4-2.7,6.2-2.7,6.2,1.2,6.2,2.7c0,2.8-.2,2.3-6.2,2.3Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "REG",
    className: "st21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "6.9 17.7 6.9 11.4 13.2 11.4 13.2 17.7 19.5 17.7 19.5 24.1 13.2 24.1 13.2 30.4 6.9 30.4 6.9 24.1 .5 24.1 .5 17.7 6.9 17.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "22.8 10.9 22.8 7.1 26.6 7.1 26.6 10.9 30.4 10.9 30.4 14.7 26.6 14.7 26.6 18.5 22.8 18.5 22.8 14.7 19 14.7 19 10.9 22.8 10.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "15.5 3 15.5 .5 18 .5 18 3 20.5 3 20.5 5.5 18 5.5 18 8 15.5 8 15.5 5.5 13 5.5 13 3 15.5 3"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "SUR",
    className: "st21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 4.4,
    y: 25.4,
    width: 22.1,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 4.4,
    y: 20.5,
    width: 22.1,
    height: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "15.5 1 1.5 12.5 4.4 12.5 4.4 20.5 26.5 20.5 26.5 12.5 29.4 12.5 15.5 1"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "WIL",
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M5.2,20.1s-.9-1.2-1.2-2.1c-.4-1.2-.4-4,0-5.3.4-1.4,2.1-4,3.3-4.9,1-.7,3.5-1.3,4.7-1.3,1.2,0,3.7.6,4.7,1.2,1.6.9,2.1,5.3,2.1,5.3l-.8,1.7.9,1.5,1.3,1.6-.4.9-1,.9v.4s.4.4.4.4l-.3.4v.5c0,0-.3.6-.3.6l-.4.5.3,1.2-.3.8-1.3.4-2.5.6-2.9-1.5s-.7,2.2-.7,3c0,.4.4,1.6.4,1.6,0,0-.8,1.2-1.2,1.4-.8.4-2.6.4-3.4.1-1.1-.4-2.8-2.4-3.4-3.4-.4-.6-.8-2.8-.8-2.8l2.3-2.4.4-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M17.4,4.5s.2,0,.5,0c.2,0,.4,0,.6.2.1,0,.2,0,.4.2.1,0,.2.2.3.3.8.8,1.5,2.1,2,3.4.5,1.3.7,2.8.7,3.9,0,.1,0,.3,0,.4,0,.1-.1.2-.2.3-.1.2-.2.4-.3.5-.2.3-.3.4-.3.4,0,0,0-.2,0-.5,0-.1,0-.3,0-.5,0-.2,0-.4,0-.7,0-1-.1-2.3-.6-3.5-.5-1.2-1.2-2.4-1.8-3.1,0,0-.2-.1-.2-.2,0-.1-.1-.2-.2-.3-.1-.2-.2-.3-.3-.4-.2-.2-.3-.4-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M19.8,2.5s.2,0,.6,0c.2,0,.4.1.7.2.1,0,.3.1.4.2.1,0,.2.2.4.3.4.5.9,1.1,1.4,1.8.4.7.8,1.5,1.1,2.3.1.4.3.8.4,1.2.1.4.2.8.3,1.2.1.8.2,1.6.1,2.2,0,.2,0,.3,0,.5,0,.1-.1.3-.2.4-.1.3-.2.5-.3.6-.2.3-.4.5-.4.5,0,0,0-.2,0-.6,0-.2,0-.4,0-.7,0-.2,0-.5,0-.8,0-.6,0-1.3-.1-2,0-.4-.1-.8-.3-1.1,0-.4-.2-.8-.4-1.1-.3-.8-.6-1.5-1-2.1-.4-.7-.8-1.2-1.2-1.6,0-.1-.2-.2-.3-.3,0-.1-.1-.2-.2-.3-.1-.2-.3-.4-.4-.5-.3-.3-.4-.4-.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M22.5.7s.2,0,.7.1c.2,0,.5.2.8.3.2,0,.3.1.4.2.1,0,.2.2.4.4.2.3.5.6.8.9.2.3.5.7.7,1.1.5.8.9,1.7,1.2,2.6.2.5.3.9.4,1.4.1.5.2.9.3,1.4.1.9.2,1.8.1,2.5,0,.2,0,.4,0,.5,0,.2-.1.3-.2.5-.1.3-.2.5-.4.7-.2.4-.4.6-.4.6,0,0,0-.2,0-.7,0-.2,0-.5,0-.7,0-.3,0-.6,0-.9,0-.7,0-1.4-.1-2.3,0-.4-.2-.8-.3-1.3-.1-.4-.3-.9-.4-1.3-.3-.8-.7-1.7-1.2-2.4-.2-.4-.5-.7-.7-1-.2-.3-.5-.6-.7-.8-.1-.1-.3-.2-.3-.3,0-.1-.2-.3-.2-.4-.2-.2-.3-.4-.5-.6-.3-.3-.5-.5-.5-.5Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "WIL_copy",
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M8,17.4s-1.1-1.4-1.5-2.5c-.5-1.5-.5-4.8,0-6.3.5-1.7,2.5-4.8,3.9-5.8,1.2-.8,4.1-1.5,5.6-1.5,1.4,0,4.4.7,5.6,1.4,1.9,1.1,2.5,6.3,2.5,6.3l-1,2,1.1,1.8,1.5,1.9-.4,1.1-1.2,1v.5s.4.5.4.5l-.4.5v.6c0,0-.3.8-.3.8l-.4.6.3,1.5-.3.9-1.5.5-2.9.8-3.4-1.8s-.8,2.6-.8,3.5c0,.5.5,1.9.5,1.9,0,0-1,1.5-1.5,1.7-.9.4-3.1.5-4,.2-1.3-.5-3.3-2.8-4-4-.4-.7-1-3.3-1-3.3l2.7-2.8.4-1.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcc);
export default __webpack_public_path__ + "static/media/acc.32e11f1c0e929a390107ffe3bcd294fa.svg";
export { ForwardRef as ReactComponent };